import { closeSnackbar, enqueueSnackbar } from "notistack";


export default function ShowSnackbar(message: string, cssClass: string) {
    enqueueSnackbar({
        message: message,
        // style: { backgroundColor: "#8fbd56" },
        className: "bg-" + cssClass
    });
}